<mat-card style="width:100%">
 <form #loginForm="ngForm">
    <mat-toolbar style="width:100%;padding: 0 8px">
      <h3 mat-line style="width:80%;color: black">{{editFitxesData.codi}}</h3>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{('fitxa.dialeg.tancar') | translate}}" attr.aria-label="{{('fitxa.dialeg.tancar') | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-right: 0" (click)="desar()" matTooltip="{{('fitxa.dialeg.desar') | translate}}" attr.aria-label="{{('fitxa.dialeg.desar') | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>
    <div style="margin-left: 10px;float:left;clear:both;padding-top:10px">
      <mat-card-content style="float:left;clear:left;width: 100px" title="{{'fitxa.dialeg.idioma' | translate}}">
        <mat-select style="float:left;clear:none;height: 25px" [(ngModel)]="editFitxesData.idioma" name="idioma" placeholder="{{('fitxa.dialeg.idioma') | translate}}" (selectionChange)="this.canviar($event)">
          <mat-option value="ca">{{ 'fitxaDialeg.idiomaCatala' | translate }}</mat-option>
          <mat-option value="en">{{ 'fitxaDialeg.idiomaAngles' | translate }}</mat-option>
          <mat-option value="es">{{ 'fitxaDialeg.idiomaCastella' | translate }}</mat-option>
          <mat-option value="pt">{{ 'fitxaDialeg.idiomaPortugues' | translate }}</mat-option>
        </mat-select>
       </mat-card-content>
    </div>
    <mat-card-content style="width:100%;float:left;clear:left;padding:5px;overflow: hidden">

    <div style="float:left;clear:both;width:100%;padding:5px;display:none">
      <mat-form-field style="float: left;clear: none;width:95%">
        <input matInput placeholder="{{('fitxa.dialeg.cmpcodi') | translate}}" name="codi" style="width:100%" [(ngModel)]="editFitxesData.codi" ngDefaultControl/>
      </mat-form-field>
    </div>

    <div style="float:left;clear:both;width:100%;padding:5px">
      <mat-form-field style="float: left;clear: none;width:95%">
        <input matInput placeholder="{{('fitxa.dialeg.cmptitol') | translate}}" name="titol" style="width:100%" [(ngModel)]="editFitxesData.titol" ngDefaultControl/>
      </mat-form-field>
    </div>
    <!-- <div style="float:left;clear:both;width:100%;padding:5px">
      <mat-form-field style="width:100%">
        <textarea matInput placeholder="{{('fitxa.dialeg.cmpdesc_projecte') | translate}}" name="desc_projecte" rows="6" [(ngModel)]="editFitxesData.desc_projecte" style="width:100%">
        </textarea>
      </mat-form-field>
    </div> -->
    <div style="float:left;clear:both;width:100%;padding:5px">
      {{ 'fitxa.dialeg.cmpdesc_projecte' | translate }}
    </div>
    <quill-editor [styles]="{height: '200px'}" class="content-editor"  [(ngModel)]="editFitxesData.desc_projecte" name="desc_projecte" id="desc_projecte"></quill-editor>

    <!-- <div style="float:left;clear:both;width:100%;padding-left: 5px">
      <mat-form-field style="width: 100%">
         <textarea matInput placeholder="{{('fitxa.dialeg.cmpdesc_serveis') | translate}}" name="desc_serveis" rows="6" [(ngModel)]="editFitxesData.desc_serveis" style="width: 100%">
         </textarea>
      </mat-form-field>
    </div> -->
    <div style="float:left;clear:both;width:100%;padding:5px">
      {{ 'fitxa.dialeg.cmpdesc_serveis' | translate }}
    </div>
    <quill-editor class="content-editor"  [styles]="{height: '200px'}" [(ngModel)]="editFitxesData.desc_serveis" name="desc_serveis" id="desc_serveis"></quill-editor>

    <div style="float:left;clear:left;width:100%;padding-bottom:30px;padding-top:30px">
       <div style="float:left;clear:left;position: absolute;width:100%;height:30px;z-index:1;background-color: white">
        <div style="float:left;clear:none;padding-top:5px;margin-left: 10px">{{ 'fitxaDialeg.carregarImatge1' | translate }}</div>
        <div style="float:left;clear:none">
          <label for="foto1">
            <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="{{ 'ticketingDialog.extensioMinuscules' | translate }}" attr.aria-label="{{ 'ticketingDialog.extensioMinuscules' | translate }}" matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
        </div>
      </div>
      <div style="float:left;clear:left;position: absolute;width:100%">
        <input mat-raised-button color="primary" type="file" filter="jpg;png;gif" style="width:80%" placeholder="" id="foto1" name="foto1" (change)="onFileChange($event, 'foto1')"/> {{ 'fitxaDialeg.maxMida5Mb' | translate }}
      </div>
    </div>
    <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:100%">
      <div class="lbl_dlg" style="float:left;clear:both;margin-left:10px;margin-top:5px;width:100%;height:100%" *ngIf="editFitxesData.foto1name"><img src="./assets/imatges/{{editFitxesData.foto1name}}" attr.alt="{{ 'fitxaDialeg.imatge1' | translate }}" attr.title="{{ 'fitxaDialeg.imatge1' | translate }}" style="width:100%"/>
      </div>&nbsp;&nbsp;{{editFitxesData.foto1name}}
      <div class="lbl_dlg" style="margin-left:10px;padding-top:20px;width:90%" *ngIf="editFitxesData.foto1name"><span style="float:left;clear:none;width:150px;margin-top:10px">{{ 'fitxaDialeg.eliminarImatge' | translate }}</span>
        <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: 5px;cursor:pointer" (click)="editFitxesData.foto1name=''" color="primary">delete_forever</mat-icon>
      </div>
    </div>
    <div style="float:left;clear:left;width:100%;padding-bottom:30px;padding-top:30px">
       <div style="float:left;clear:left;position: absolute;width:100%;height:30px;z-index:1;background-color: white">
        <div style="float:left;clear:none;padding-top:5px;margin-left: 10px">{{ 'fitxaDialeg.carregarImatge2' | translate }}</div>
        <div style="float:left;clear:none">
          <label for="foto2">
            <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="{{ 'ticketingDialog.extensioMinuscules' | translate }}" attr.aria-label="{{ 'ticketingDialog.extensioMinuscules' | translate }}" matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
        </div>
      </div>
      <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button color="primary" type="file" filter="jpg;png;gif" style="width:80%" placeholder="" id="foto2" name="foto2" (change)="onFileChange($event, 'foto2')"/> {{ 'fitxaDialeg.maxMida5Mb' | translate }}
      </div>
    </div>
    <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:100%">
      <div class="lbl_dlg" style="float:left;clear:both;margin-left:10px;margin-top:10px;width:100%;height:100%" *ngIf="editFitxesData.foto2name"><img src="./assets/imatges/{{editFitxesData.foto2name}}" attr.alt="{{ 'fitxaDialeg.imatge2' | translate }}" attr.title="{{ 'fitxaDialeg.imatge2' | translate }}" style="width:100%"/>
      </div>&nbsp;&nbsp;{{editFitxesData.foto2name}}
      <div class="lbl_dlg" style="margin-left:10px;padding-top:10px;width:90%" *ngIf="editFitxesData.foto2name"><span style="float:left;clear:none;width:150px;margin-top:10px">{{ 'fitxaDialeg.eliminarImatge' | translate }}</span>
        <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: 5px;cursor:pointer" (click)="editFitxesData.foto2name=''" color="primary">delete_forever</mat-icon>
      </div>
    </div>
    <div style="float:left;clear:both;margin-top:0px;width:90%;padding-left:20px;background-color:#3f51b5" *ngIf="error !== ''">
      <span style="color:red;font-weight: bold">{{error}}</span>
    </div>

    </mat-card-content>
  </form>
</mat-card>
